<div class="input-group">
  <div class="input-tax">
    <div class="input-group">
      <span class="wrap-baht" [class.hint]="!model && model !== 0">฿</span>
      <input type="text" class="form-control" placeholder="" inputmode="decimal"
             [ngModel]="model | number"
             (ngModelChange)="onModelChange($event)"
             (focusout)="onFocusout()"
             (focusin)="onFocusin()"
             itaxNumberOnly
      />
    </div>
  </div>
</div>
